import { httpClient } from '../http/httpClient'

export interface PanLinkResponse {
  linkOperador: string
  linkCliente: string
}

export async function getLink(id: string) {
  const { data } = await httpClient.get<PanLinkResponse>(`/pan/${id}/link`)
  return data
}
